/**
 * "What's new" — product release notes shown in the app (E-UX). Newest first. `version` is what
 * the user's `whats_new_seen` preference is compared with: a newer entry puts a dot on the menu.
 * Keep entries short, plain-language and about what the user can now DO.
 */
export interface Release { version: string; date: string; title: string; items: string[] }

export const RELEASES: Release[] = [
  {
    version: '2026.10',
    date: '2026-10-02',
    title: 'Easier, safer everyday use',
    items: [
      'Show or hide your password while you type, with a warning when Caps Lock is on.',
      'Two-step verification: protect your account with an authenticator app and one-time recovery codes (My profile → Security).',
      'See every device you are signed in on and sign out of all the others in one click.',
      'Dark mode and a compact layout for long registers (My profile → Preferences, or the user menu).',
      'Search for people, payroll runs and tickets from the search box (Ctrl K), and jump back to recently viewed pages.',
      'Star any page to keep it in your favourites. Press ? to see keyboard shortcuts.',
      'You are warned before being signed out after a period of inactivity, and can stay signed in.',
    ],
  },
]

export const LATEST_RELEASE = RELEASES[0]?.version ?? null
